var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.256 6.91073C12.5814 7.23617 12.5814 7.76381 12.256 8.08925L8.92263 11.4226C8.59719 11.748 8.06956 11.748 7.74412 11.4226L6.07745 9.75591C5.75201 9.43048 5.75201 8.90284 6.07745 8.5774C6.40289 8.25196 6.93053 8.25196 7.25596 8.5774L8.33337 9.65481L11.0775 6.91073C11.4029 6.5853 11.9305 6.5853 12.256 6.91073Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16663 3.33332C5.94496 3.33332 3.33329 5.94499 3.33329 9.16666C3.33329 12.3883 5.94496 15 9.16663 15C12.3883 15 15 12.3883 15 9.16666C15 5.94499 12.3883 3.33332 9.16663 3.33332ZM1.66663 9.16666C1.66663 5.02452 5.02449 1.66666 9.16663 1.66666C13.3088 1.66666 16.6666 5.02452 16.6666 9.16666C16.6666 13.3088 13.3088 16.6667 9.16663 16.6667C5.02449 16.6667 1.66663 13.3088 1.66663 9.16666Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3275 13.3274C13.6529 13.002 14.1805 13.002 14.506 13.3274L18.0893 16.9108C18.4147 17.2362 18.4147 17.7638 18.0893 18.0893C17.7639 18.4147 17.2362 18.4147 16.9108 18.0893L13.3275 14.5059C13.002 14.1805 13.002 13.6529 13.3275 13.3274Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchCheck);
export default __webpack_public_path__ + "static/media/search_check.3764cc8c65fbdec50e1f34fa1d1e244e.svg";
export { ForwardRef as ReactComponent };